import { TFreightCapabilitySchema } from 'transfix-form/forms/CarrierFleetInformation/components/FreightCapabilityModal/schema/FreightCapabilitySchema'
import { Maybe } from 'types/FMSGraphqlTypes'
import { TFreightCapabilities } from '../types'

export const getFreightCapabilitiesDefaultValues = (
  freightCapabilities: Maybe<TFreightCapabilities>
): TFreightCapabilitySchema => {
  const { isDrayageCapable, isFtlCapable, isIntermodalCapable, isLtlCapable } =
    freightCapabilities || {}
  return {
    isIntermodalCapable: isIntermodalCapable || false,
    isFtlCapable: isFtlCapable || false,
    isLtlCapable: isLtlCapable || false,
    isDrayageCapable: isDrayageCapable || false,
  }
}
